<template>
  <div 
    class="main-content-title"
    style="max-width: 1400px; width: 100%; margin: 0 auto;"
  >
    <h2 style="font-size: 28px;">{{ $t("title.notice") }}</h2>
  </div>
  <div>
    <BoardList />
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import BoardList from "./board/BoardList.vue";
import { storeToRefs } from "pinia";
import { useNoticesStore } from "@/store/notices";

export default defineComponent({
  name: "Notice",
  components: { BoardList },
  setup() {
    const noticesStore = useNoticesStore();
    const {
      noticeType,
      noticeDetailType,
      searchKeyword,
    } = storeToRefs(noticesStore);

    onMounted(() => {
      noticeType.value = 1;
      noticeDetailType.value = localStorage.getItem("productType") || 1;
      searchKeyword.value = '';

      noticesStore.fetchNotices();
    });

    return {
    };
  },
});
</script>
